import { useCallback, useMemo } from 'react';

import type { TableSort } from './Table.js';

/**
 * Превращает клик по заголовку в новую сортировку и собирает токен для API.
 *
 * Состояние живёт снаружи - у нас это search params маршрута, поэтому хук
 * принимает текущее значение и сеттер, а сам ничего не хранит. Повторный клик по
 * активной колонке переворачивает направление, клик по новой - выбирает её по
 * возрастанию.
 */
export const useTableSort = (
  sort: TableSort,
  onSortChange: (next: TableSort) => void,
) => {
  const toggleSort = useCallback(
    (field: string) => {
      const dir = sort.field === field && sort.dir === 'asc' ? 'desc' : 'asc';
      onSortChange({ field, dir });
    },
    [sort, onSortChange],
  );

  /** Токен для query-параметра sort бэкенда: 'code' или 'code:desc'. */
  const sortParam = useMemo(() => `${sort.field}:${sort.dir}`, [sort]);

  return { toggleSort, sortParam };
};
